<template>
    <b-card no-body class="nsp-card">
        <b-card-header class="d-flex align-items-center">
            <span class="nsp-title">{{ name || $t('NSP_AC') }}</span>
            <b-badge class="ml-auto" :variant="ac.on ? 'success' : 'secondary'">
                {{ ac.on ? $t('NSP_ON') : $t('NSP_OFF') }}
            </b-badge>
        </b-card-header>

        <b-card-body>
            <div class="d-flex align-items-center mb-3">
                <b-button
                    :variant="ac.on ? 'success' : 'outline-secondary'"
                    size="lg"
                    class="nsp-power"
                    v-on:click="$emit('power', !ac.on)">
                    <i class="icon-power"></i>
                </b-button>
                <div class="ml-3">
                    <div class="nsp-big">{{ ac.temp }}<small v-if="ac.temp !== '-'">&#8451;</small></div>
                    <div class="text-muted small">{{ $t('NSP_AC_TARGET_TEMP') }}</div>
                </div>
            </div>

            <b-button-group class="w-100">
                <b-button
                    :variant="ac.mode === 'heat' ? 'danger' : 'outline-secondary'"
                    :disabled="!ac.on"
                    v-on:click="$emit('mode', 'heat')">{{ $t('NSP_HEAT') }}</b-button>
                <b-button
                    :variant="ac.mode === 'cool' ? 'info' : 'outline-secondary'"
                    :disabled="!ac.on"
                    v-on:click="$emit('mode', 'cool')">{{ $t('NSP_COOL') }}</b-button>
                <b-button
                    :variant="ac.mode === 'fan' ? 'primary' : 'outline-secondary'"
                    :disabled="!ac.on"
                    v-on:click="$emit('mode', 'fan')">{{ $t('NSP_FAN') }}</b-button>
            </b-button-group>

            <div class="text-muted small mt-3">
                {{ $t('NSP_AC_SETPOINTS', { cool: acTemp.cool, heat: acTemp.heat }) }}
            </div>
            <div class="text-muted small">
                {{ $t('NSP_ROOM_TEMP_RANGE') }}:
                {{ ac.lowestTemperature }}&#8451; - {{ ac.highestTemperature }}&#8451;
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
export default
{
    name: 'AcCard',
    props:
    {
        name:
        {
            type: String,
            default: '',
        },
        ac:
        {
            type: Object,
            required: true,
        },
        // ir setpoints configured in site_props key 'acTemp'
        acTemp:
        {
            type: Object,
            required: true,
        },
    },
};
</script>
